import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'hideCitations',
  standalone: true,
})
export class HideCitationsPipe implements PipeTransform {
  transform(content: string, shouldHide: boolean) {
    return shouldHide ? content.replace(/\s*\[\d+\]/gm, '') : content;
  }
}
